module.exports = __webpack_public_path__ + "img/washout.4601b312.svg";